// extracted by mini-css-extract-plugin
module.exports = {"volume":"volume_volume__31Q2X","checkbox":"volume_checkbox__1_7lN","label":"volume_label__3qpPi options_label__3yThe"};